export default {
  data () {
    return {
      momentStatusCache: new Map() // Cache for moment statuses
    }
  },

  methods: {
    getMomentStatus (moment) {
      // Use cached status if available
      const cacheKey = `${moment.extendedProps.ActivityID}-${moment.extendedProps.WarehouseID}-${moment.start}`
      if (this.momentStatusCache.has(cacheKey)) {
        return this.momentStatusCache.get(cacheKey)
      }

      const status = this.getReservationStatus(moment)
      this.momentStatusCache.set(cacheKey, status)
      return status
    },

    getReservationStatus (moment) {
      // Check if MaxEntryQuantity is enabled
      if (!moment.extendedProps.MaxEntryQuantity) {
        return null
      }

      // Check if moment has children and if any of them are reservable
      if (moment.children?.length) {
        const hasReservableChild = moment.children.some(child => {
          const childStatus = this.getReservationStatus(child)
          return childStatus?.canReserve
        })

        if (hasReservableChild) {
          return {
            variant: 'outline-success',
            text: this.$t('actions.reserve'),
            canReserve: true
          }
        }

        return null
      }

      const now = new Date()
      const endDateTime = new Date(moment.end)
      const maxReserveDate = new Date()
      maxReserveDate.setDate(maxReserveDate.getDate() + (moment.extendedProps['Activity.ReserveDaysInAdvance'] || 14))
      maxReserveDate.setHours(23, 59, 59)

      // Check if beyond max reserve date
      if (maxReserveDate < endDateTime) {
        return null
      }

      // Check if expired
      if (now > endDateTime) {
        return {
          variant: 'outline-dark',
          text: this.$t('timetable.expired'),
          canReserve: false
        }
      }

      // Check max quantity and queue settings
      const maxQuantityReached = Number(moment.extendedProps.CurrentEntryQuantity || 0) >= Number(moment.extendedProps.MaxEntryQuantity || 0)
      const attendanceQueueEnabled = moment.extendedProps['Activity.QueueAttendanceYN']

      if (maxQuantityReached) {
        if (attendanceQueueEnabled) {
          return {
            variant: 'warning',
            text: this.$t('reservation.queue'),
            canReserve: true,
            showQueueCount: true
          }
        } else {
          return {
            variant: 'outline-dark',
            text: this.$t('timetable.timeslot_full'),
            canReserve: false
          }
        }
      }

      // Default case - can reserve
      return {
        variant: 'outline-success',
        text: this.$t('actions.reserve'),
        canReserve: true
      }
    }
  }
}
